import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { CreazionePraticaStoreService } from '../../services/creazione-pratica-store.service';
import { Scadenza } from 'src/app/common/models/scadenza';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { stepMap } from '../creazione-pratica-stepper/config/step';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { OperationsService } from 'src/app/core/services/operations.service';
import { DocumentoAddModal } from 'src/app/common/components/documenti/documento-add/documento-add-modal.component';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { ScadenzaResponse } from 'src/app/common/models/dto/scadenza-response';
import { ScadenzaModRinvioComponent } from 'src/app/common/components/fascicolo/scadenzario-rinvio/scadenza-mod-rinvio.component';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';
import { DocumentVersionHistoryModal } from 'src/app/common/components/documenti/documento-history-version/document-version-history-modal.component';
import { DocumentUpdateMetadatiModal } from 'src/app/common/components/documenti/documento-update-metadati/document-update-metadati-modal.component';
import { DocumentVersionUpdateModal } from 'src/app/common/components/documenti/documento-version-update/document-version-update-modal.component';
import { UtilityCommon } from 'src/app/common/utils/utility-common';
import { ScadenzarioRequest } from 'src/app/common/models/scadenzario-request';
import { ScadenzaModAutoAddComponent } from 'src/app/common/components/fascicolo/scadenzario-auto-add/scadenza-mod-auto-add.component';
import { ScadenzaEvadiComponent } from 'src/app/common/components/fascicolo/scadenza-evadi/scadenza-evadi.component';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { DettaglioAdempimentoMod } from 'src/app/common/components/fascicolo/dettaglio-adempimenti/dettaglio-adempimento-mod';
import { UpdateMetadatiComponent } from 'src/app/common/components/fascicolo/documentazione-allegata-view/metadati/update-metadati/update-metadati.component';

declare var closeModal: any;
@Component({
  selector: 'step-adempimenti',
  templateUrl: './step-adempimenti.component.html',
  styleUrls: ['./step-adempimenti.component.css']
})
export class StepAdempimentiComponent implements OnInit, OnDestroy {

  currentTab: string = TABS.LIST;
  tabs = TABS;
  scadenze: Scadenza[] = [];
  scadenzaTmp: Scadenza = null;
  accordions = stepMap;
  sezione = null;
  fascicolo = null;
  lastRinvioScadenzaTemp: any | null = null;
  subscriptionEvadi: Subscription;
  private componentDestroyed$: Subject<void> = new Subject<void>();
  @ViewChild('docAddModalScadenze') docAddModalScadenze: DocumentoAddModal;
  @ViewChild('modaleRinvioScadenza') modaleRinvioScadenza: ScadenzaModRinvioComponent;
  @ViewChild('docVersionHistoryScadenze') docVersionHistoryScadenze: DocumentVersionHistoryModal;
  @ViewChild('docVersionUpdateModalScadenze') docVersionUpdateModalScadenze: DocumentVersionUpdateModal;
  @ViewChild('adempimentiScadenzaAutoAddModal') adempimentiScadenzaAutoAddModal: ScadenzaModAutoAddComponent;
  @ViewChild('esitoAddModal', { static: false }) esitoAddModal: DettaglioAdempimentoMod;
  @Output() changeStep: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private creazionePraticaStoreService: CreazionePraticaStoreService,
    private operations: OperationsService,
    private modalNotifyService: ModalNotifyService,
    private viewManager: ViewManagerService,
    private dialog: DialogService
  ) {
    // this.creazionePraticaStoreService.scadenze$.pipe(takeUntil(this.componentDestroyed$)).subscribe(response => {
    //   this.scadenze = response;
    //   console.log(response, 'called')
    //   // this.getLastRinvioAdempimento();
    //   // Aggiornamento della proprietà lastRinvioScadenza per ogni scadenza
    //   // this.scadenze.forEach(scadenza => {
    //   // // Controlla se scadenza.rinvioScadenza è definito e non vuoto
    //   // if (scadenza.rinvioScadenza && scadenza.rinvioScadenza.length > 0) {        
    //   //   scadenza.lastRinvioScadenza = this.lastRinvioScadenzaTemp;        
    //   // }})
      
    //   if(this.scadenze == null) this.scadenze = [];
    // });
    this.creazionePraticaStoreService.scadenze$.pipe(takeUntil(this.componentDestroyed$)).subscribe(response => {
      this.scadenze = response;
      if(this.scadenze == null) this.scadenze = [];
    });
    this.creazionePraticaStoreService._docAdd.subscribe(
      data => {
        if(data?.tipoSezione?.descrizione === "SCADENZARIO") {
            if(!!this.sezione) {
              this.sezione.documentiAggregati = data.documentiAggregati
              this.getLastRinvioAdempimento(data.scadenze);
              this.scadenze = [...data.scadenze];
              this.creazionePraticaStoreService.setAdempimenti(data.scadenze);
              this.creazionePraticaStoreService.save();
            }
          }
        
      }
    )
  }

  ngOnInit() {
    this.readSezione();
    /*else{
      this.currentTab = TABS.LIST;
    }*/
    //TSR-653 Lo step degli adempimenti nel wizard di creazione deve mostrare di default la lista degli adempimenti inseriti (eventualmente vuota) e non il form di inserimento.
  }

  ngOnDestroy(){
    this.componentDestroyed$.next();
    this.creazionePraticaStoreService.setAdempimenti(null);
    this.creazionePraticaStoreService.save();
    if(this.subscriptionEvadi) this.subscriptionEvadi.unsubscribe();
  }

  setTab(type: string){
    this.currentTab = type;
  }

  onEmitAdempimentoSubmit(scadenza: Scadenza){
    // this.scadenze.push(scadenza);
    this.scadenzaTmp = scadenza;
    // console.log(this.scadenze);
    // this.creazionePraticaStoreService.setAdempimenti(this.scadenze);
    // this.creazionePraticaStoreService.save();
    this.salva();
    this.currentTab = TABS.LIST;
  }

  reset(): void{
    this.scadenze = [];
    this.creazionePraticaStoreService.setAdempimenti(this.scadenze);
    this.creazionePraticaStoreService.save();
  }

  salva(): void{
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_SCADENZARIO_FASCICOLO);
    let idSezione =
      !!this.accordions[index].properties.fascicolo.idSezioneScadenze
        ? this.accordions[index].properties.fascicolo.idSezioneScadenze
        : "new";
    let idFascicolo = this.accordions[index].properties.fascicolo.id;
    let tipoPratica = this.accordions[index].properties.tipoPratica.endpoint;
    let tipoFascicolo = this.accordions[index].properties.tipoFascicolo.endpoint;
    if(this.scadenze.findIndex(x => x.id === this.scadenzaTmp.id) < 0) {
      this.add(index, idSezione, idFascicolo);
    } else {
      this.update(tipoPratica, tipoFascicolo, idSezione, index, idFascicolo);
    }
  }

  private add(index: number, idSezione: string, idFascicolo: string) {
    this.operations.addNewScadenza(
      this.scadenzaTmp,
      this.accordions[index].properties.urlInsert,
      idSezione,
      idFascicolo
    ).subscribe(res => {
      this.scadenze = [...res.sezione.scadenze];
      this.creazionePraticaStoreService.setAdempimenti(this.scadenze);
      this.creazionePraticaStoreService.save();
      let request = new ScadenzarioRequest(
        this.accordions[index].properties.tipoPratica,
        this.accordions[index].properties.tipoFascicolo, 
        this.accordions[index].properties.fascicolo.grado, 
        null, 
        null, 
        this.scadenzaTmp.tipoScadenza, 
        this.scadenzaTmp.motivo, 
        null, 
        null, 
        null, 
        this.accordions[index].properties.fascicolo.natura,
        this.accordions[index].properties.fascicolo.tipoRicorso
      )
      this.checkScadenze(request, index, res);
      this.operations.readFascicolo(this.accordions[index].properties.urlInsert, idFascicolo).subscribe(
        res => {
          this.accordions.forEach(x => x.properties.fascicolo = res.fascicolo);
          this.accordions[index].complete = true;
          this.readSezione();
          this.scadenzaTmp = null;
        }
      );
    });
  }

  private checkScadenze(request: ScadenzarioRequest, index: number, res: any) {
    this.operations.ciSonoScadenze('exists', request)
      .subscribe(response => {
        if (response && response.length > 0) {
          response.forEach(element => {
            if (element.label === 'SCADENZA' && this.scadenzaTmp.dataScadenza) {
              this.openAutoAddModal(this.scadenzaTmp, request, index, res);
              return;
            }
          });
        }
      });
  }

  private openAutoAddModal(scadenza: Scadenza, request, index, sezione) {
    this.adempimentiScadenzaAutoAddModal.initFormCreazioneRapida(
      scadenza, 
      request, 
      this.accordions[index].properties.fascicolo.natura, 
      sezione.lastID, 
      this.accordions[index].properties.fascicolo.id,
      'adempimentiScadenzaAutoAddModal'
    )
  }


  private update(
    tipoPratica: string, 
    tipoFascicolo: string, 
    idSezione: string, 
    index: number, 
    idFascicolo: string
  ) {
    this.operations.updateNewScadenza(
      this.scadenzaTmp,
      tipoPratica,
      tipoFascicolo,
      idSezione
    ).subscribe(res => {
      this.scadenze = [...res.sezione.scadenze];
      this.creazionePraticaStoreService.setAdempimenti(this.scadenze);
      this.creazionePraticaStoreService.save();
      this.operations.readFascicolo(this.accordions[index].properties.urlInsert, idFascicolo).subscribe(
        res => {
          this.accordions.forEach(x => x.properties.fascicolo = res.fascicolo);
          this.accordions[index].complete = true;
          this.readSezione();
          this.scadenzaTmp = null;
        }
      );
    });
  }

  onDeleteScadenza(opt: {scadenza: Scadenza, index: number}) {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_SCADENZARIO_FASCICOLO);
    let idSezione = this.accordions[index].properties.fascicolo.idSezioneScadenze;
    this.delete(opt.scadenza, idSezione, index, opt.index);
  }

  private delete(scadenza: Scadenza, idSezione:string, indexAccordion:number, index:number) {
    this.operations.deleteNewScadenza(
      this.accordions[indexAccordion].properties.urlInsert, 
      idSezione, 
      scadenza.id
    ).subscribe(
      res => {
        this.scadenze.splice(index, 1);
        this.creazionePraticaStoreService.setAdempimenti(this.scadenze);
        this.creazionePraticaStoreService.save();
        this.readSezione();
      }
    )
  }


  readSezione() {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_SCADENZARIO_FASCICOLO);
    let tipoPratica = this.accordions[index].properties.tipoPratica.endpoint;
    let tipoFascicolo = this.accordions[index].properties.tipoFascicolo.endpoint;
    let idSezione = this.accordions[index].properties.fascicolo.idSezioneScadenze || null;
    let url = `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/scadenze`;
    if(!idSezione) return;
    this.operations.readSezione(url, idSezione).subscribe(response => {
      this.fascicolo = this.accordions[index].properties.fascicolo;
      this.accordions[index].properties.sezione = response.sezione;
      this.accordions[index].properties.sezione["esn"] = NomiDescrittoriSezione.SEZIONE_SCADENZARIO_FASCICOLO;
      this.getLastRinvioAdempimento(response.sezione.scadenze);
      this.creazionePraticaStoreService.onSectionLoaded(response.sezione);
      this.creazionePraticaStoreService.setAdempimenti(response.sezione.scadenze);
      this.creazionePraticaStoreService.save();
      this.scadenze = response.sezione.scadenze;
      this.sezione = response.sezione;
      this.accordions[index].complete = true;
    });
  }

  getLastRinvioAdempimento(scadenze: Array<Scadenza>){
    for (let i = 0; i < scadenze.length; i++) {
      if (scadenze[i].rinvioScadenza && scadenze[i].rinvioScadenza.length > 0) {
        scadenze[i].rinvioScadenza = UtilityCommon.orderBy(scadenze[i].rinvioScadenza,'dataDa:DESC');
        scadenze[i].lastRinvioScadenza = scadenze[i].rinvioScadenza[0];
        for (let r = 0; r <scadenze[i].rinvioScadenza.length; r++) {
          scadenze[i].rinvioScadenza[r].ora = UtilityCommon.formattaOra(scadenze[i].rinvioScadenza[r].ora);
        }
      } 
      let dateObj = new Date();
      //dateObj.setHours(0, 0, 0, 0);
      let date = dateObj.getTime();
      if (!scadenze[i].evasa && date > scadenze[i].dataScadenza) {
        let giorniRitardo = Math.ceil((date - scadenze[i].dataScadenza) / (1000 * 60 * 60 * 24));
        if (giorniRitardo > 0) {
          scadenze[i].giorniRitardo = giorniRitardo;
        }
      }
    }
  }


  onDropDownEvent(event: {
    scadenza: Scadenza,
    eventType: 'rinvio' | 'allegato' | 'evadi' | 'elimina' | 'aggiungiEsitoUdienza' | 'modificaDettaglioUdienza' | 'eliminaDettaglioUdienza',
    index: number
  }) {
    switch (event.eventType) {
      case "elimina":
        let option = {scadenza: event.scadenza, index: event.index}
        this.onDeleteScadenza(option);
        break;
      case "allegato":
        this.attachDocument(event);
        break;
      case "rinvio":
        this.openRinvioModal(event.scadenza);
        break;
      case "evadi":
        this.evadi(event.scadenza);
        break;
      case "aggiungiEsitoUdienza":
        this.aggiungiEsitoUdienza(event);
        break;
      case "modificaDettaglioUdienza":
        this.modificaDettaglioUdienza(event);
        break;
      case "eliminaDettaglioUdienza":
        this.eliminaDettaglioUdienza(event);
        break;
      default:
        break;
    }
  }

  openRinvioModal(scadenza: Scadenza) {
    this.modaleRinvioScadenza.inizializza(
      this.getUrlAddRinvioScadenza(),
      scadenza,
      this.sezione.id
    );
  }

  evadi(scadenza: Scadenza) {
    this.subscriptionEvadi = this.modalNotifyService.notifyConfirmObservable.subscribe(
      (result) => {
        if (!!result) {
          this.openDialogEvadi(result, scadenza);
        }
        else{
          this.subscriptionEvadi.unsubscribe();
        }
      });
    this.modalNotifyService.notifyEvadiScadenza();
  }

  openDialogEvadi(result: boolean, scadenza) {
    this.subscriptionEvadi.unsubscribe();
    const ref = this.dialog.open(ScadenzaEvadiComponent, {
      data: {
        style: {
          width: '50%',
        },
        idAdempimento: scadenza.id,
        title: 'Evadi adempimento',
      }
    });
    ref.afterClosed.subscribe((event) => {
      if(!event || event.closeEvent) return;
      if(event.dataEvasione) {
        let payload = {
          dataEvasione: event.dataEvasione, 
          motivoEvasione: event.motivoEvasione
        };
        this.executeEvasione(result, scadenza, payload)
      }
    });
  }

  executeEvasione(result: boolean, scadenza: Scadenza, payload) {
    if (result) {
      this.operations
        .evadiScadenza(
          this.getEvadiScadenzaEndpoint(),
          scadenza.id,
          this.sezione.id,
          payload
        ).subscribe((response) => this.scadenzaEvasa((<ScadenzaResponse>response).scadenza))
    }
    if (this.subscriptionEvadi) {
      this.subscriptionEvadi.unsubscribe();
    }
  }

  setScadenza(scadenza: Scadenza) {
    let ind = this.sezione.scadenze.findIndex((s) => s.id === scadenza.id);
    this.sezione.scadenze[ind] = scadenza;
    this.readSezione();
  }

  scadenzaEvasa(scadenza: Scadenza) {
    this.viewManager._prossimiAdempimenti.next({param: null, timeOut:true});
    this.setScadenza(scadenza);
  }

  private getEvadiScadenzaEndpoint() {
    let { tipoPratica, tipoFascicolo, idSezione } = this.getProps();
    return (
      ServicePathsSettings.OPERATIONS_PATH +
      ServicePathsSettings.GESTIONE_PRATICHE_PATH +
      '/' +
      tipoPratica +
      '' +
      ServicePathsSettings.URL_FASCICOLO +
      '/' +
      tipoFascicolo +
      ServicePathsSettings.URL_EVADI_SCADENZA
    );
  }

  private getUrlAddRinvioScadenza() {
    let { tipoPratica, tipoFascicolo, idSezione } = this.getProps();
    return (
      ServicePathsSettings.OPERATIONS_PATH +
      ServicePathsSettings.GESTIONE_PRATICHE_PATH +
      '/' +
      tipoPratica +
      '' +
      ServicePathsSettings.URL_FASCICOLO +
      '/' +
      tipoFascicolo +
      ServicePathsSettings.URL_ADD_RINVIO_SCADENZA
    );
  }

  private getProps() {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_SCADENZARIO_FASCICOLO);
    let tipoPratica = this.accordions[index].properties.tipoPratica.endpoint;
    let tipoFascicolo = this.accordions[index].properties.tipoFascicolo.endpoint;
    let idSezione = this.accordions[index].properties.fascicolo.idSezioneScadenze || null;
    return { tipoPratica, tipoFascicolo, idSezione };
  }

  private aggiungiEsitoUdienza(event: { scadenza: Scadenza; eventType: 'rinvio' | 'allegato' | 'evadi' | 'elimina' | 'aggiungiEsitoUdienza' | 'modificaDettaglioUdienza' | 'eliminaDettaglioUdienza'; }) {
    this.esitoAddModal.inizializza(
      this.sezione,
      event.scadenza.id,
      this.getUrlEsitoToScadenza(),    
      this.fascicolo,
      true,
     );
  }

  private modificaDettaglioUdienza(event: { scadenza: Scadenza; eventType: 'rinvio' | 'allegato' | 'evadi' | 'elimina' | 'aggiungiEsitoUdienza' | 'modificaDettaglioUdienza' | 'eliminaDettaglioUdienza'; }) {
    this.esitoAddModal.inizializza(
      this.sezione,
      event.scadenza.id,
      this.getUrlEsitoToScadenza(),    
      this.fascicolo,
      false,
      event.scadenza.dettaglioEsitoAdempimento,
     );
  }

  private eliminaDettaglioUdienza(event: { scadenza: Scadenza; eventType: 'rinvio' | 'allegato' | 'evadi' | 'elimina' | 'aggiungiEsitoUdienza' | 'modificaDettaglioUdienza' | 'eliminaDettaglioUdienza'; }) {
    const urlEsitoToScadenza = this.getUrlDeleteEsitoToScadenza()
      .replace("{entityId}", event.scadenza.id)
      .replace("{idDettaglioAdempimento}", event.scadenza.dettaglioEsitoAdempimento.id);
      this.operations.deleteDettaglioAdempimento(urlEsitoToScadenza).subscribe(response => {
        this.readSezione();
        this.viewManager.updateIntestazione();
      });
  }

  private attachDocument(event: { scadenza: Scadenza; eventType: 'rinvio' | 'allegato' | 'evadi' | 'elimina' | 'aggiungiEsitoUdienza' | 'modificaDettaglioUdienza' | 'eliminaDettaglioUdienza'; }) {
    this.docAddModalScadenze.initFormAlternative(
      this.getUrlAddDocToScadenza(),
      this.sezione, 
      this.fascicolo.id, 
      false, 
      this.sezione.esn, 
      'Aggiungi documento - Scadenze', 
      true, 
      event.scadenza
    );
  }

  private getUrlAddDocToScadenza() {
    return ServicePathsSettings.URL_ADD_DOCUMENTO_TO_SCADENZA;
  }

  getUrlDeleteEsitoToScadenza() {
    return ServicePathsSettings.URL_DELETE_ESITO_TO_SCADENZA;
  }

  getUrlEsitoToScadenza() {
    return ServicePathsSettings.URL_ESITO_TO_SCADENZA;
  }

  closeModalDocumentAndReadSezione() {
    closeModal('docVersionUpdateModalScadenze');
    closeModal('docAddModalScadenze');
    closeModal('adempimentiScadenzaAutoAddModal');
    this.readSezione();
  }

  editScadenza(index:number) {
    this.scadenzaTmp = this.scadenze[index];
    this.currentTab = TABS.CREATE;
  }

  onDocumentEvent(event: {
    documento: DocumentoAllegato,
    scadenza?: Scadenza,
    entityId?: string,
    sezioneId?: string,
    eventType: 'nuova-versione' | 'storico' | 'modifica' | 'elimina' | 'metadati'
  }) {
    switch (event.eventType) {
      case "elimina":
        this.removeDoc(event.documento, event.entityId);
        break;
      case "metadati":
        this.displayDocUpdateMetadatiModal(event.documento);
        break;
      case "nuova-versione":
        this.showUploadNewVersionModal(event.documento);
        break;
      case "storico":
        this.showHistoryModal(event.documento);
        break;
      default:
        break;
    }
  }

  private removeDoc(documento: DocumentoAllegato, entityId: string) {
    this.operations.removeDocumentoToEntity(documento, this.getUrlRemoveDocFromScadenza(), entityId)
      .subscribe(() =>{ 
        this.readSezione();
      });
  }

  private showHistoryModal(documento: DocumentoAllegato) {
    this.docVersionHistoryScadenze.initContentCreazioneRapida(documento, this.fascicolo, 'docVersionHistoryScadenze');
  }

  private displayDocUpdateMetadatiModal(documento: DocumentoAllegato) {
    const ref = this.dialog.open(UpdateMetadatiComponent, {
      data: {
        style: { width: "70%"},
        title: 'Modifica metadati',
        documento: documento,
        fascicolo: this.fascicolo,
        tipoPratica: this.fascicolo?.praticaBase.tipoPratica.id
      }
    });
     ref.afterClosed.subscribe(event => {
      if(!event || event.closeEvent) {
        // documento.primary = false;
        return
      };
      if(!!event.response) {
        this.closeModalDocumentAndReadSezione();
      }
    });
  }

  private showUploadNewVersionModal(documento: DocumentoAllegato) {
    this.docVersionUpdateModalScadenze.initFormCreazioneRapida(documento, 'docVersionUpdateModalScadenze');
  }

  private getUrlRemoveDocFromScadenza() {
    return ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_SCADENZA;
  }

}

export enum TABS{
  LIST = 'list',
  CREATE = 'create'
}
